"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyStateIndicator = EmptyStateIndicator;
exports.emptyIndicatorTarget = void 0;
exports.getEmptyStateIndicator = getEmptyStateIndicator;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _roles = require("../../../utils/roles.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Paragraph = _typography.default.Paragraph;
var defaultPreviewMsg = 'No messages yet';
var emptyIndicatorTarget = {
  PREVIEW: 'PREVIEW',
  CHAT: 'CHAT'
};
exports.emptyIndicatorTarget = emptyIndicatorTarget;
function getEmptyStateIndicator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    text = _ref.text,
    type = _ref.type,
    role = _ref.role;
  return function () {
    return /*#__PURE__*/_react.default.createElement(EmptyStateIndicator, {
      text: text,
      type: type,
      role: role
    });
  };
}
function EmptyStateIndicator(_ref2) {
  var text = _ref2.text,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? emptyIndicatorTarget.CHAT : _ref2$type,
    role = _ref2.role;
  var getOne2OneChatEmpty = function getOne2OneChatEmpty(_ref3) {
    var text = _ref3.text,
      role = _ref3.role;
    var defaultTextByRole = {
      1: 'Start messaging in order to set the time and data of your first appointment.',
      2: "The purpose of this chatroom is for you to discuss medication concern or side effects with your ".concat((0, _roles.getRoleNameLower)(_roles.UserRoles.Doctor), "."),
      4: 'The purpose of this chatroom is for you to schedule video calls with your therapist.'
    };
    return /*#__PURE__*/_react.default.createElement(_row.default, {
      type: "flex",
      justify: "center"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 16
    }, /*#__PURE__*/_react.default.createElement(Paragraph, {
      type: "secondary"
    }, text || defaultTextByRole[role || 1])));
  };
  var Indicator;
  switch (type) {
    case emptyIndicatorTarget.CHAT:
      Indicator = getOne2OneChatEmpty({
        text: text,
        role: role
      });
      break;
    case emptyIndicatorTarget.PREVIEW:
      Indicator = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, text || defaultPreviewMsg);
      break;
    default:
      Indicator = /*#__PURE__*/_react.default.createElement("p", {
        className: "mb-[1em]"
      }, "No items");
      break;
  }
  return Indicator;
}